import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { UserProfileModel } from '../../models/userProfileModel';
import { Observable, throwError, map, catchError, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TimeCardModel } from 'src/app/models/timeCardModel';
import { PayPeriodModel } from 'src/app/models/payPeriodModel';
import { ClientSimpleModel } from 'src/app/models/clientSimpleModel';


@Injectable()
export class PayPeriodService {

  constructor(private http: HttpClient) {
  }

  loadPayPeriods(loadAll: boolean): Observable<PayPeriodModel[]> {
    return this.http.get<PayPeriodModel[]>(`${environment.apiServer.webApiURL}/TimeCard/PayPeriods/?loadAll=${loadAll}`,);
  }


}
